import { Check } from "lucide-react";
import { STATUTS } from "@/lib/dossiers";
import { cn } from "@/lib/utils";

export default function StatutSelector({ value, onChange }) {
    return (
        <div data-testid="statut-selector" className="space-y-2">
            <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground text-right">Statut du dossier</p>
            <div className="inline-flex rounded-full border border-border bg-card p-1 text-sm">
                {Object.entries(STATUTS).map(([k, label]) => (
                    <button
                        key={k}
                        type="button"
                        data-testid={`statut-option-${k}`}
                        aria-pressed={value === k}
                        onClick={() => value !== k && onChange(k)}
                        className={cn(
                            "flex items-center gap-1.5 px-4 py-1.5 rounded-full transition-colors",
                            value === k ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
                        )}
                    >
                        {value === k && <Check className="h-3.5 w-3.5" strokeWidth={2.5} />}
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
}
